var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "pyramid" } },
    [
      _c("GChart", {
        ref: "gChart",
        attrs: {
          settings: { packages: ["corechart", "bar"] },
          data: _vm.chartdata,
          options: _vm.chartOptions,
          createChart: function(el, google) {
            return new google.charts.Bar(el)
          },
          events: _vm.chartEvents
        },
        on: { ready: _vm.onChartReady }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }